import { useEffect, useState, type RefObject } from "react";

// Visibility of an element as React state (false during prerender and until the first IO callback).
// Used to pause loops (PendingStack, how carousel) while off screen.
export function useInView(
  ref: RefObject<Element | null>,
  opts: IntersectionObserverInit = { threshold: 0 },
): boolean {
  const [inView, setInView] = useState(false);
  const { root, rootMargin, threshold } = opts;

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === "undefined") return;
    const io = new IntersectionObserver(([e]) => setInView(e.isIntersecting), {
      root,
      rootMargin,
      threshold,
    });
    io.observe(el);
    return () => io.disconnect();
  }, [ref, root, rootMargin, threshold]);

  return inView;
}
